/**
 * Calendar dates -- the date printed on a receipt -- as opposed to moments in time.
 *
 * The API sends a purchase date as `YYYY-MM-DD` because that is what the paper says, with no
 * time and no zone (CLAUDE.md: dates printed on paper are `DateField`). The obvious way to show
 * one is wrong: `new Date("2026-10-01")` is midnight UTC, which in Alberta is still 30 September,
 * so the receipt would display the day before it was bought. Formatting in UTC keeps the date
 * the date.
 */

export function formatCalendarDate(isoDate: string, locale = "en-CA"): string {
  return new Intl.DateTimeFormat(locale, { dateStyle: "medium", timeZone: "UTC" }).format(
    new Date(`${isoDate}T00:00:00Z`),
  );
}

/** Today as `YYYY-MM-DD` in the device's own zone, which is what a date input expects. */
export function todayIso(now: Date = new Date()): string {
  const local = new Date(now.getTime() - now.getTimezoneOffset() * 60_000);
  return local.toISOString().slice(0, 10);
}

/**
 * The day a moment in time falls on, in the given zone: when a trial ends, say, shown as the
 * workspace's own calendar sees it rather than the device's.
 */
export function formatMomentDate(iso: string, timeZone: string, locale = "en-CA"): string {
  return new Intl.DateTimeFormat(locale, { dateStyle: "medium", timeZone }).format(new Date(iso));
}
